import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "exam-timer d-flex align-center" }
const _hoisted_2 = { class: "remaining-time" }
const _hoisted_3 = { class: "time-limit" }

import { ref, watch, computed, onMounted, onBeforeUnmount } from 'vue'
import { secondsToHmsNumber } from '../../utils/utils'
import { format } from 'date-fns'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamTimer',
  props: {
    time: {},
    timeLimit: {},
    startTime: {}
  },
  emits: ["time-up"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

let timer: number | null = null
const remainingTime = ref(0)
const endTimestamp = ref(0)

const stopTimer = () => {
  if (timer !== null) {
    clearInterval(timer)
    timer = null
  }
}

const updateRemainingTime = () => {
  const now = Date.now()
  const remaining = Math.max(0, Math.floor((endTimestamp.value - now) / 1000))

  remainingTime.value = remaining

  if (remainingTime.value <= 0) {
    stopTimer()
    emit('time-up')
  }
}

const startTimer = () => {
  stopTimer()
  timer = window.setInterval(() => {
    updateRemainingTime()
  }, 1000)
}

const handleVisibilityChange = () => {
  if (document.hidden) {
    stopTimer()
  } else {
    updateRemainingTime()
    startTimer()
  }
}

watch(() => props.time, (newTime) => {
  remainingTime.value = newTime

  if (props.startTime) {
    const startTimestamp = new Date(props.startTime).getTime()
    endTimestamp.value = startTimestamp + (props.timeLimit * 60 * 1000)
  } else {
    endTimestamp.value = Date.now() + (remainingTime.value * 1000)
  }

  startTimer()
}, { immediate: true })

onMounted(() => {
  startTimer()
  document.addEventListener('visibilitychange', handleVisibilityChange)
})

onBeforeUnmount(() => {
  stopTimer()
  document.removeEventListener('visibilitychange', handleVisibilityChange)
})

const endTime = computed(() => {
  if (!props.startTime) return ''
  const endTimeMs = new Date(props.startTime).getTime() + props.timeLimit * 60 * 1000
  return format(new Date(endTimeMs), 'HH:mm:ss')
})

const formatDate = (time: string | number) => {
  if (!time) return ''
  return format(new Date(time), 'HH:mm:ss')
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(secondsToHmsNumber)(remainingTime.value)) + "/", 1 /* TEXT */),
    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.timeLimit) + "min", 1 /* TEXT */),
    _createVNode(_component_v_progress_circular, {
      class: "ms-2 timer-progress",
      "model-value": 100 - ((remainingTime.value * 100) / (__props.timeLimit * 60)),
      "bg-color": "#2699fb",
      color: "#eeeeee",
      width: 3,
      size: 24
    }, null, 8 /* PROPS */, ["model-value"])
  ]))
}
}

})